<template>
  <section class="section conference-detail-section">
    <button type="button" class="text-link" @click="front.goPath('/services')">返回学会服务</button>
    <article v-if="front.activeConferenceDetail" class="conference-detail-card">
      <span class="tag">{{ front.activeConferenceDetail.status }}</span>
      <h2>{{ front.activeConferenceDetail.title }}</h2>
      <p>{{ front.activeConferenceDetail.branch }} · {{ front.activeConferenceDetail.city }} · {{ front.activeConferenceDetail.time }}</p>
      <dl>
        <div>
          <dt>学生会员</dt>
          <dd>{{ front.formatFee(front.activeConferenceDetail.feeRules.studentMember) }}</dd>
        </div>
        <div>
          <dt>非学生会员</dt>
          <dd>{{ front.formatFee(front.activeConferenceDetail.feeRules.nonStudentMember) }}</dd>
        </div>
        <div>
          <dt>学生非会员</dt>
          <dd>{{ front.formatFee(front.activeConferenceDetail.feeRules.studentNonMember) }}</dd>
        </div>
        <div>
          <dt>非学生非会员</dt>
          <dd>{{ front.formatFee(front.activeConferenceDetail.feeRules.nonStudentNonMember) }}</dd>
        </div>
      </dl>
      <div class="conference-rules">
        <span v-for="rule in front.activeConferenceDetail.materialRules" :key="rule">{{ rule }}</span>
        <span v-for="rule in front.activeConferenceDetail.submissionRules" :key="rule">{{ rule }}</span>
      </div>
      <div class="detail-actions">
        <button type="button" class="primary-action compact" @click="front.startConferenceRegistration(front.activeConferenceDetail)">报名会议</button>
        <button type="button" class="ghost-action compact" @click="front.goPath('/downloads-center')">查看资料下载</button>
      </div>
    </article>
    <article v-else class="empty-state">
      <p class="section-kicker">会议详情</p>
      <h2>未找到会议</h2>
    </article>
  </section>
</template>

<script>
export default {
  name: 'ConferenceDetailPage',
  inject: ['front']
}
</script>
